import React, {useEffect, useRef, useState} from 'react'

const Search = props => {
  const [showSearch, setShowSearch] = useState(false)
  const [typeSelected, setTypeSelected] = useState('title')
  const [searchValue, setSearchValue] = useState('')
  const searchRef = useRef()
  const timer = useRef()

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target) && event.target.name != 'search-input') setShowSearch(false)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [searchRef])

  const handleTypeChanged = type => {
    setTypeSelected(type)
    if (searchValue) props.onSearch({type: type, value: searchValue})
  }

  const onChangeSearch = (value) => {
    setSearchValue(value)

    clearTimeout(timer.current)
    timer.current = setTimeout(()=> props.onSearch({type: typeSelected, value: value}), 500)
  }

  return (
    <div className='search-container'>
      <input
        type='text'
        name='search-input'
        placeholder='Search'
        onClick={() => setShowSearch(true)}
        onChange={e => onChangeSearch(e.target.value)}
      />
      <div className='search-dropdown'>
        <div id='search-dropdown' ref={searchRef} className={`search-content ${showSearch ? 'open' : '' }`}>
          <div className='search-types'>
            <div
              onClick={ () => handleTypeChanged('title') }
              className={`search-type ${typeSelected == 'title' && 'active'}`}>
                Title
            </div>
            <div
              onClick={ () => handleTypeChanged('location') }
              className={`search-type ${typeSelected == 'location' && 'active'}`}>
                Location
            </div>
            <div
              onClick={ () => handleTypeChanged('body') }
              className={`search-type ${typeSelected == 'body' && 'active'}`}>
                Message
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Search
